import { Navigate, useRoutes } from 'react-router-dom';
import { PublicRoutes } from './public';
import { ProtectedRoutes } from './protected';
import { getCookie } from '@/utils/storage';
import PublicDataRoomWrapper from '@/HOCs/PublicDataRoomWrapper';
import DataRoomsMain from '@/features/dataRooms/views/DataRoomsMain';
import Vote from '@/features/vote/views/vote';
import PublicVoteWrapper from '@/HOCs/PublicVoteWrapper';
import WepayPaymentCallback from '@/features/company/components/myActivity/WepayPaymentCallback';

const AppRoutes = () => {
  const isAuthenticated = getCookie('access_token') || false;
  const routes = isAuthenticated ? ProtectedRoutes : PublicRoutes;

  const element = useRoutes([
    {
      path: '/payment/callback',
      element: <WepayPaymentCallback />,
    },
    {
      path: '/shared/files/:uuid',
      element: (
        <PublicDataRoomWrapper>
          <DataRoomsMain />
        </PublicDataRoomWrapper>
      ),
    },
    {
      path: '/vote/questions/:meetingID/public',
      element: (
        <PublicVoteWrapper>
          <Vote />
        </PublicVoteWrapper>
      ),
    },
    ...routes,
    // Add a catch-all route for unauthorized access
    {
      path: '*',
      element: <Navigate to={isAuthenticated ? '/' : '/auth/signin'} replace />,
    },
  ]);

  return <>{element}</>;
};

export default AppRoutes;
